import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  videos: [],
};

export const dashboardVideosSlice = createSlice({
  name: 'dashboardVideos',
  initialState,
  reducers: {
    setVideos: (state, action) => {
      state.videos = action.payload;
    },
  },
});

export const { setVideos } = dashboardVideosSlice.actions;

export default dashboardVideosSlice.reducer;
